import React, { useState } from 'react'
import styled from 'styled-components'
import Select from 'react-select'
import { TargetTitle } from 'src/components/Global/Text/TitleText'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
import { useTypedSelector } from 'src/redux/root-reducer'
import { CustomModal } from 'src/components/Global/Modal'
import { PlanTypes } from 'src/redux/types/planTypes'
import { TargetCheckbox } from 'src/components/Global/CheckBox/Checkbox'
import { SavingsSelectInput } from 'src/components/Global/SelectBox/Select'
import { CreateTargetWrapper, FormContainer } from './createTargetStyle'
import { DatePicker } from 'src/components/Global/Date/Date'
import storageController from 'src/utils/storageController'
import { PlanCreatedDetails } from '../createPlans/PlanDetails'
import { SingleSelect } from 'src/components/Global/Date/DatePicker'
import getStoredState from 'redux-persist/es/getStoredState'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'

const CreateTargetContinue = () => {
  let location = useLocation()
  const [error, isError] = useState(false)
  const [automatedChecked, setautomatedChecked] = useState(true)
  const [manualChecked, setmanualChecked] = useState(false)
  const [planData, setPlanData] = useState({
    start_date: '',
    maturity_date: '',
    saving_type: 'manual',
  })
  const [automated, setAutomated] = useState(true)

  const { start_date, maturity_date, saving_type } = planData
  let data: any = useTypedSelector((state) => state.userPlanReducer.planForm)
  console.log(data, 'planform')

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    console.log(planData)
    dispatch(action(PlanTypes._UPDATE_PLAN_FORM, newData))
  }
  const dispatch = useDispatch()

  const handleautomatedOnChange = () => {
    setautomatedChecked(!automatedChecked)
    setmanualChecked(!manualChecked)
  }

  const handleManualOnChange = () => {
    setmanualChecked(!manualChecked)
    setautomatedChecked(!automatedChecked)
    setAutomated(!automated)
  }
  const handleSubmit = (e: any) => {
    e.preventDefault()
    if (manualChecked) {
      planData.saving_type = 'manual'
    }
    // if (automatedChecked) {
    //   planData.saving_type = 'automated'
    // }

    if (!start_date || !maturity_date || !saving_type) {
      isError(true)
    }
    console.log(planData)
  }
  const [showModal, setShowModal] = useState(false)

  const openModal = () => {
    setShowModal((prev) => !prev)
  }
  const Disabled = () => {
    if (!start_date || !maturity_date || !saving_type) {
      return 'blur'
    }
    return null
  }
  return (
    <FormContainer>
      <CreateTargetWrapper onSubmit={handleSubmit}>
        <TargetTitle className="targetTitle">Create Plan</TargetTitle>
        <div className="input">
          <h4>Start Date</h4>
          <DatePicker
            type="date"
            value={start_date}
            onChange={handleChange}
            name="start_date"
            placeholder="Start Date"
          />
        </div>

        <div className="input">
          <h4>End Date</h4>
          <DatePicker
            type="date"
            value={maturity_date}
            onChange={handleChange}
            name="maturity_date"
            placeholder="End Date"
          />
        </div>
        <div className="destination">
          <h4>Saving Frequency</h4>
          <div className="frequency">
            <label className="container">
              Automated
              <input
                type="radio"
                checked={automatedChecked}
                name="saving_type"
                value="saving_type"
                onChange={handleautomatedOnChange}
              />
              <span className="checkmark"></span>
            </label>
            {automatedChecked && (
              <Link
                to={`/savings-frequency`}
                state={{ backgroundLocation: location }}
              >
                <div className="reverse">Monthly(tap to change)</div>
              </Link>
            )}
          </div>
          <label className="container">
            Manually
            <input
              type="radio"
              checked={manualChecked}
              name="saving_type"
              value={saving_type}
              onChange={handleManualOnChange}
            />
            <span className="checkmark"></span>
          </label>
        </div>

        <Link
          to={'/plan-created-details'}
          state={{ backgroundLocation: location }}
        >
          <ModalButton className={`target ${Disabled()}`}>
            Create Pin
          </ModalButton>
        </Link>
      </CreateTargetWrapper>
    </FormContainer>
  )
}

export { CreateTargetContinue }
